import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { getBoqCategoryItemApi, getBoqCategoryListApi, getBoqItemHierarchyPathApi, getBoqNumberListApi, getBoqSubCategoryListApi, getItemsApi, getvendorsApi } from '../../utils/ApiEndpointFunctions';
import moment from 'moment';
import { useUserContext } from '../../context/userContext';
import AsyncSelect from 'react-select/async';
import Spinwheel from '../common/Spinwheel';
import ConfirmationModal from './ConfirmationModal';


function BillingFilter(props) {
  const { formik, index, isDisable, filterDetails, handleResetFilter, resetDbData, billType } = props
  const { langPreference, userDetails } = useUserContext()
  const [vendors, setVendors] = useState()
  const [categoryList, setCategoryList] = useState([])
  const [subCategoryList, setSubCategoryList] = useState([])
  const [subCategoryLoading, setSubCategoryLoading] = useState(false)
  const [boqNumberList, setBoqNumberList] = useState([])
  const [boqNumberLoading, setBoqNumberLoading] = useState(false)
  const [items, setItems] = useState()
  const [boqHierarchySelections, setBoqHierarchySelections] = useState([])
  const [lastFilterRestored, setLastFilterRestored] = useState(false)
  const confirmModalId = `resetBillingConfirmModalId${index+1}`
  const lastFilterStorageKey = `billing-last-filter-${userDetails?._id || "default"}-${billType || "all"}`
  const isClientBilling = billType === "client"
  const singleLineSelectStyles = {
    option: (provided) => ({
      ...provided,
      overflow: "hidden",
      whiteSpace: "nowrap",
    }),
    singleValue: (provided) => ({
      ...provided,
      overflow: "hidden",
      whiteSpace: "nowrap",
    }),
  }

  const formatBoqNumber = (value) => {
    if (value === undefined || value === null || value === "") return "-"
    return Number(value).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  const getCountLabel = (name, itemCount = 0) => `${name}${itemCount ? ` (${itemCount} ${langPreference?.boq_items || "BOQ items"})` : ""}`

  const getBucketOption = (item) => {
    const name = typeof item === "string" ? item : item?.name
    const itemCount = typeof item === "string" ? 0 : item?.itemCount
    if (!name) return null
    return { label: getCountLabel(name, itemCount), value: name, itemCount }
  }

  const getMiddleShortText = (text = "", startLength = 28, endLength = 13) => {
    const cleanText = String(text || "").replace(/\s+/g, " ").trim()
    if (cleanText.length <= startLength + endLength + 5) return cleanText
    return `${cleanText.slice(0, startLength).trim()} ... ${cleanText.slice(-endLength).trim()}`
  }

  const getBoqOptionText = (option, context = "menu") => {
    const fullText = option?.value?.fullDetails || option?.value?.nameAndDetails || option?.label || ""
    return context === "value" ? getMiddleShortText(fullText, 25, 10) : getMiddleShortText(fullText, 28, 12)
  }

  const getMissingFilterFields = () => {
    const missingFields = []
    if (isClientBilling && !formik?.values?.category) missingFields.push(langPreference?.category || "Category")
    if (isClientBilling && !formik?.values?.subCategory) missingFields.push(langPreference?.sub_category || "Sub-category")
    if (isClientBilling && !formik?.values?.boqItemId) missingFields.push(langPreference?.boq_item || "BOQ Item")
    if (!formik?.values?.vendorId) missingFields.push(isClientBilling ? (langPreference?.vendor_subcontractor || "Vendor/Sub-contractor") : (langPreference?.subcontractor_name || "Sub-contractor"))
    if (!formik?.values?.uniqueItemId) missingFields.push(isClientBilling ? (langPreference?.work_item_service || "Work item / service") : (langPreference?.subcontractor_item_service || "Subcontractor item / service"))
    if (!formik?.values?.to || !formik?.values?.from) missingFields.push(langPreference?.date || "Date")
    return missingFields
  }

  const saveLastFilters = () => {
    const values = formik?.values || {}
    const lastFilters = {
      category: values?.category || "",
      subCategory: values?.subCategory || "",
      boqId: values?.boqId || "",
      boqNumber: values?.boqNumber || "",
      boqItemId: values?.boqItemId || "",
      vendorId: values?.vendorId || "",
      vendorName: values?.vendorName || "",
      uniqueItemId: values?.uniqueItemId || "",
      Item: values?.Item || "",
      to: values?.to ? new Date(values.to).getTime() : "",
      from: values?.from ? new Date(values.from).getTime() : "",
    }
    localStorage.setItem(lastFilterStorageKey, JSON.stringify(lastFilters))
  }

  const restoreLastFilters = () => {
    if (lastFilterRestored || isDisable || filterDetails?.category || !billType) return
    try {
      const savedFilters = JSON.parse(localStorage.getItem(lastFilterStorageKey) || "{}")
      if (isClientBilling && !savedFilters?.category) {
        setLastFilterRestored(true)
        return
      }

      formik.setFieldValue("category", savedFilters?.category || "")
      formik.setFieldValue("subCategory", savedFilters?.subCategory || "")
      formik.setFieldValue("boqId", savedFilters?.boqId || "")
      formik.setFieldValue("boqNumber", savedFilters?.boqNumber || "")
      formik.setFieldValue("vendorId", savedFilters?.vendorId || "")
      formik.setFieldValue("vendorName", savedFilters?.vendorName || "")
      formik.setFieldValue("uniqueItemId", savedFilters?.uniqueItemId || "")
      formik.setFieldValue("Item", savedFilters?.Item || "")
      if (savedFilters?.to) formik.setFieldValue("to", new Date(savedFilters.to))
      if (savedFilters?.from) formik.setFieldValue("from", new Date(savedFilters.from))
      if (savedFilters?.boqItemId) {
        formik.setFieldValue("boqItemId", savedFilters.boqItemId)
        getBoqItemHierarchyPath(savedFilters.boqItemId)
      }
    } catch (error) {
      console.log(error)
    }
    setLastFilterRestored(true)
  }

  const setDateRange = (startDate, endDate) => {
    formik.setFieldValue("to", startDate)
    formik.setFieldValue("from", endDate)
  }

  const setDatePreset = (preset) => {
    if (preset === "today") {
      setDateRange(moment().startOf("day").toDate(), moment().endOf("day").toDate())
      return
    }

    if (preset === "lastMonth") {
      setDateRange(moment().subtract(1, "month").startOf("month").toDate(), moment().subtract(1, "month").endOf("month").toDate())
      return
    }

    if (preset === "thisWeek") {
      setDateRange(moment().startOf("week").toDate(), moment().endOf("day").toDate())
      return
    }

    setDateRange(moment().startOf("month").toDate(), moment().endOf("day").toDate())
  }

  const isFinalBoqItem = (item = {}) => {
    const isLegacyItem = item?.hasUTRA === undefined && !item?.uuid && !item?.parentUuid && !item?.level
    return item?.isFinalBoqItem || item?.hasUTRA === true || isLegacyItem
  }

  const resetBoqItemSelection = () => {
    setBoqHierarchySelections([])
    formik.setFieldValue("categoryItem", "")
    formik.setFieldValue("boqItemId", "")
  }

  const setFinalBoqItem = (item) => {
    formik.setFieldValue("categoryItem", item || "")
    formik.setFieldValue("boqItemId", item?._id || "")
  }



  const getVendors = async () => {
    try {
      let type = "Sub-Contractor"
      const res = await getvendorsApi("", "", "", type)
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.vendors?.map(ele => ({ label: ele.name, value: ele }))
        setVendors(fetchedItem);
        if (filterDetails?.vendorId) {
          let selectedVendor = fetchedItem?.filter(ele => ele?.value?._id == filterDetails?.vendorId)?.[0]
          formik.setFieldValue("vendorName", selectedVendor?.label)
          formik.setFieldValue("vendorId", filterDetails?.vendorId)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getCategoryList = async () => {
    try {
      const res = await getBoqCategoryListApi()
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.map(getBucketOption)?.filter(Boolean)
        setCategoryList(fetchedItem);
        if (filterDetails?.category) {
          formik.setFieldValue("category", fetchedItem?.filter(ele => ele?.value == filterDetails?.category)?.[0]?.value)

        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  const getSubCategoryList = async (category) => {
    try {
      if (!category) {
        setSubCategoryList([])
        setSubCategoryLoading(false)
        return
      }
      setSubCategoryLoading(true)
      const res = await getBoqSubCategoryListApi(category)
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.map(getBucketOption)?.filter(Boolean)
        setSubCategoryList(fetchedItem);
        if (filterDetails?.subCategory) {
          formik.setFieldValue("subCategory", fetchedItem?.filter(ele => ele?.value == filterDetails?.subCategory)?.[0]?.value)
        } else if (!formik?.values?.subCategory && fetchedItem?.length === 1) {
          formik.setFieldValue("subCategory", fetchedItem[0]?.value)
        }
      }
    } catch (error) {
      console.log(error)
    }
    setSubCategoryLoading(false)
  }
  const getBoqNumberList = async (category, subCategory) => {
    try {
      if (!category || !subCategory) {
        setBoqNumberList([])
        setBoqNumberLoading(false)
        return
      }
      setBoqNumberLoading(true)
      const res = await getBoqNumberListApi(category, subCategory)
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.map(ele => ({ label: ele.boqNumber, value: ele }))
        setBoqNumberList(fetchedItem);
        if (filterDetails?.boqId) {
          let selectedBoq = fetchedItem?.filter(ele => ele?.value?._id == filterDetails?.boqId)?.[0]
          formik.setFieldValue("boqId", selectedBoq?.value?._id || "")
          formik.setFieldValue("boqNumber", selectedBoq?.label || "")
        }
      }
    } catch (error) {
      console.log(error)
    }
    setBoqNumberLoading(false)
  }
  const getItems = async (vendorId) => {
    try {
      if (!vendorId) {
        setItems([])
        return
      }
      const res = await getItemsApi("", "", "", vendorId);
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.items?.map(ele => ({ label: ele.name, value: ele }))
        setItems(fetchedItem);
        if (filterDetails?.uniqueItemId) {
          formik.setFieldValue("Item", fetchedItem?.filter(ele => ele?.value?.uniqueItemId == filterDetails?.uniqueItemId)?.[0]?.label)
          formik.setFieldValue("uniqueItemId", filterDetails?.uniqueItemId)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getBoqItemHierarchyPath = async (boqItemId) => {
    try {
      if (!boqItemId) return
      const res = await getBoqItemHierarchyPathApi(boqItemId)
      if (res.status === 200) {
        const path = res?.data?.data || []
        setBoqHierarchySelections(path)
        const finalItem = path?.[path.length - 1]
        if (finalItem) {
          setFinalBoqItem(finalItem)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getVendors()
    if (isClientBilling) getCategoryList()
    if (filterDetails?.date) {
      let dateRange = filterDetails?.date?.split("-")
      if (dateRange?.length == 2) {
        formik?.setFieldValue("to", new Date(new Date().setTime(filterDetails?.date?.split("-")?.[0])))
        formik?.setFieldValue("from", new Date(new Date().setTime(filterDetails?.date?.split("-")?.[1])))

      }
    } else if (!isDisable && !formik?.values?.to && !formik?.values?.from) {
      setDatePreset("thisMonth")
    }
    restoreLastFilters()
  }, [filterDetails, billType])

  useEffect(() => {
    getSubCategoryList(formik?.values?.category)
  }, [formik?.values?.category])

  useEffect(() => {
    getBoqNumberList(formik?.values?.category, formik?.values?.subCategory)
  }, [formik?.values?.category, formik?.values?.subCategory])

  useEffect(() => {
    getItems(formik?.values?.vendorId)
  }, [formik?.values?.vendorId])

  useEffect(() => {
    if (filterDetails?.boqItemId) {
      getBoqItemHierarchyPath(filterDetails?.boqItemId)
    }
  }, [filterDetails?.boqItemId])

  const handleSelectDate = (e, type) => {
    formik.setFieldValue(type, e)
  };

  const loadBoqHierarchyOptions = async (inputValue, levelIndex = 0) => {
    const category = formik?.values?.category
    const subCategory = formik?.values?.subCategory
    const boqId = formik?.values?.boqId
    const parentUuid = levelIndex > 0 ? boqHierarchySelections?.[levelIndex - 1]?.uuid : ""
    if (category && subCategory) {
      if (levelIndex > 0 && !parentUuid) {
        return []
      }
      try {
        const res = await getBoqCategoryItemApi(inputValue, category, subCategory, boqId, parentUuid)
        if (res.status === 200) {
          let fetchedItem = res.data?.data
            ?.map(ele => ({ label: getMiddleShortText(ele?.fullDetails || ele?.nameAndDetails, 28, 12), value: ele }))
            ?.sort((firstItem, secondItem) => firstItem?.label?.localeCompare(secondItem?.label || "") || 0)

          if (!inputValue && fetchedItem?.length === 1 && !boqHierarchySelections?.[levelIndex] && !isDisable) {
            setTimeout(() => handleBoqHierarchySelect(fetchedItem[0], levelIndex), 0)
          }

          return fetchedItem
        }
      } catch (error) {
        console.log(error)
      }
    }
    return []
  };

  const handleBoqHierarchySelect = (e, levelIndex) => {
    if (e.__isNew__) {
      formik.resetForm();
    } else {
      const selectedPath = [...boqHierarchySelections.slice(0, levelIndex), e.value]
      setBoqHierarchySelections(selectedPath)
      if (isFinalBoqItem(e.value)) {
        setFinalBoqItem(e.value)
      } else {
        setFinalBoqItem("")
      }
    }
  }

  const handleConfirmation = () => {
    !resetDbData && handleResetFilter()
    document.getElementById(confirmModalId).click()
  }

  const handleApply = async () => {
    const errors = await formik.validateForm()
    const touchedFields = Object.keys(formik?.values || {}).reduce((fields, key) => ({ ...fields, [key]: true }), {})
    formik.setTouched(touchedFields)
    if (Object.keys(errors || {}).length) return
    saveLastFilters()
    formik.handleSubmit()
  }

  const missingFilterFields = getMissingFilterFields()
  const finalBoqItem = formik?.values?.categoryItem
  const selectedCategoryOption = categoryList?.find(ele => ele?.value === formik?.values?.category)
  const selectedSubCategoryOption = subCategoryList?.find(ele => ele?.value === formik?.values?.subCategory)
  const selectedVendorOption = formik?.values?.vendorId
    ? vendors?.find(ele => String(ele?.value?._id) === String(formik.values.vendorId))
    : null
  const selectedItemOption = formik?.values?.uniqueItemId
    ? items?.find(ele => String(ele?.value?.uniqueItemId) === String(formik.values.uniqueItemId))
    : null
  const vendorLabel = isClientBilling ? (langPreference?.vendor_subcontractor || "Vendor/Sub-contractor") : (langPreference?.subcontractor_name || "Sub-contractor")
  const itemServiceLabel = isClientBilling ? (langPreference?.work_item_service || "Work item / service") : (langPreference?.subcontractor_item_service || "Subcontractor item / service")


  return (
    <>
      <div className="">
        <div className="">
          <form >
            <div className="row align-items-start">
              {isClientBilling && <>
              <div className="ed-box col-12 col-md-6 col-xl-3">
                <label htmlFor="category" className="form-label">{langPreference?.category || "Category"} <span className='req-error'>*</span></label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={isDisable}
                  value={formik?.values?.category ? (selectedCategoryOption || { label: formik?.values?.category, value: formik?.values?.category }) : null}
                  placeholder={langPreference?.select || "Select "}
                  isSearchable={true}
                  name="category"
                  options={categoryList}
                  onChange={(e) => {
                    formik.setFieldValue("category", e.value)
                    setSubCategoryList([])
                    formik.setFieldValue("subCategory", "")
                    formik.setFieldValue("boqId", "")
                    formik.setFieldValue("boqNumber", "")
                    resetBoqItemSelection()
                  }}
                />
                <div className='text-danger'>{(formik?.touched?.category && formik?.errors?.category)}</div>
              </div>
              <div className="ed-box col-12 col-md-6 col-xl-3">
                <label htmlFor="subCategory" className="form-label">{langPreference?.sub_category || "Sub-category"} <span className='req-error'>*</span></label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={!formik?.values?.category || isDisable}
                  value={formik?.values?.subCategory ? (selectedSubCategoryOption || { label: formik?.values?.subCategory, value: formik?.values?.subCategory }) : null}
                  placeholder={langPreference?.select || "Select "}
                  isSearchable={true}
                  name="subCategory"
                  options={subCategoryList}
                  onChange={(e) => {
                    formik.setFieldValue("subCategory", e.value)
                    formik.setFieldValue("boqId", "")
                    formik.setFieldValue("boqNumber", "")
                    resetBoqItemSelection()
                  }}
                />
                {!formik?.values?.category && !isDisable && <small className="text-muted">{langPreference?.select_category_first || "Select category first"}</small>}
                {formik?.values?.category && subCategoryLoading && !isDisable && <small className="text-muted">{langPreference?.loading_sub_categories || "Loading sub-categories..."}</small>}
                {formik?.values?.category && !subCategoryLoading && !subCategoryList?.length && !isDisable && <small className="text-muted">{langPreference?.no_sub_category_found || "No sub-category found for this category"}</small>}
                <div className='text-danger'>{(formik?.touched?.subCategory && formik?.errors?.subCategory)}</div>
              </div>
              <div className="ed-box col-12 col-md-6 col-xl-2">
                <label htmlFor="boqNumber" className="form-label">{langPreference?.boq_number || "BOQ Number"}</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={!formik?.values?.category || !formik?.values?.subCategory || isDisable}
                  value={formik?.values?.boqNumber ? { label: formik?.values?.boqNumber } : null}
                  placeholder={boqNumberLoading ? "Loading..." : (langPreference?.select || "Select ")}
                  isSearchable={true}
                  isClearable={true}
                  name="boqNumber"
                  options={boqNumberList}
                  onChange={(e) => {
                    formik.setFieldValue("boqNumber", e?.label || "")
                    formik.setFieldValue("boqId", e?.value?._id || "")
                    resetBoqItemSelection()
                  }}
                />
                {formik?.values?.category && formik?.values?.subCategory && !boqNumberLoading && !boqNumberList?.length && !isDisable && <small className="text-muted">{langPreference?.no_boq_number_found || "No BOQ number found"}</small>}
              </div>
              <div className="w-100"></div>
              {[0, 1, 2, 3].map((levelIndex) => {
                const previousSelection = boqHierarchySelections?.[levelIndex - 1]
                const shouldShowLevel = levelIndex === 0 || (previousSelection && !isFinalBoqItem(previousSelection))
                if (!shouldShowLevel) return null
                const selectedItem = boqHierarchySelections?.[levelIndex]
                return (
                  <div className="ed-box col-12 col-md-6 col-xl-3" key={`boq-level-${levelIndex}`}>
                    <label htmlFor={`boqLevel${levelIndex}`} className="form-label">
                      {levelIndex === 0 ? (langPreference?.boq_item || "BOQ Item") : `${langPreference?.boq_sub_item_level || "BOQ Sub Item L"}${levelIndex + 1}`} <span className='req-error'>*</span>
                    </label>
                    <div className='w-100 cursor-pointer' >
                      <AsyncSelect
                        key={`${formik?.values?.category}-${formik?.values?.subCategory}-${formik?.values?.boqId || "all"}-${levelIndex}-${previousSelection?.uuid || "root"}`}
                        name={`boqLevel${levelIndex}`}
                        style={{ cursor: "pointer !important" }}
                        isDisabled={!formik?.values?.category || !formik?.values?.subCategory || isDisable}
                        className='col w-100'
                        styles={singleLineSelectStyles}
                        placeholder={langPreference?.select || "Select"}
                        loadingMessage={() => langPreference?.loading_boq_items || "Loading BOQ items..."}
                        noOptionsMessage={() => formik?.values?.category && formik?.values?.subCategory ? (langPreference?.no_boq_item_found || "No BOQ item found") : (langPreference?.select_category_sub_category_first || "Select category and sub-category first")}
                        cacheOptions={false}
                        value={selectedItem?.nameAndDetails ? { label: getMiddleShortText(selectedItem?.fullDetails || selectedItem?.nameAndDetails, 25, 10), value: selectedItem } : null}
                        formatOptionLabel={(option, { context }) => getBoqOptionText(option, context)}
                        loadOptions={(inputValue) => loadBoqHierarchyOptions(inputValue, levelIndex)}
                        defaultOptions
                        onChange={(e) => { handleBoqHierarchySelect(e, levelIndex) }}
                      />
                    </div>
                    {levelIndex === 0 && !formik?.values?.category && !isDisable && <small className="text-muted">{langPreference?.select_category_first || "Select category first"}</small>}
                    {levelIndex === 0 && formik?.values?.category && !formik?.values?.subCategory && !isDisable && <small className="text-muted">{langPreference?.select_sub_category_first || "Select sub-category first"}</small>}
                    {levelIndex > 0 && !selectedItem && !isDisable && <small className="text-muted">{langPreference?.select_final_boq_item || "Select final BOQ item"}</small>}
                    {levelIndex === 0 && <div className='text-danger'>{(formik?.touched?.categoryItem && formik?.errors?.categoryItem)}</div>}
                  </div>
                )
              })}
              <div className="w-100"></div>
              <div className="ed-box col-12 col-lg-9 col-xl-10">
                <label htmlFor="item_name_details" className="form-label">{langPreference?.item_name_details || "Item Name and Details"}</label>
                {boqHierarchySelections?.length ? boqHierarchySelections.map((item, itemIndex) => (
                  <p className="mb-1" key={`${item?.uuid || item?._id || itemIndex}`}>{item?.fullDetails || item?.nameAndDetails}</p>
                )) : <p>{formik?.values?.categoryItem?.fullDetails}</p>}
              </div>
              <div className="ed-box col-12 col-sm-4 col-lg-3 col-xl-2">
                <label htmlFor="serialNumber" className="form-label">{langPreference?.boq_item_s_no || "BOQ Item Serial Number"}</label>
                <p>{boqHierarchySelections?.[0]?.sNo || formik?.values?.categoryItem?.sNo}</p>
              </div>
              {finalBoqItem?._id && (
                <div className="ed-box col-12">
                  <div className="d-flex flex-wrap gap-3 border rounded px-3 py-2 bg-light">
                    <span><strong>{langPreference?.serial_no || "S. No"}:</strong> {boqHierarchySelections?.[0]?.sNo || finalBoqItem?.sNo || "-"}</span>
                    <span><strong>{langPreference?.unit || "Unit"}:</strong> {finalBoqItem?.unitType || "-"}</span>
                    <span><strong>{langPreference?.qty || "Qty"}:</strong> {formatBoqNumber(finalBoqItem?.quantity)}</span>
                    <span><strong>{langPreference?.rate || "Rate"}:</strong> {formatBoqNumber(finalBoqItem?.unitPrice)}</span>
                    <span><strong>{langPreference?.amount || "Amount"}:</strong> {formatBoqNumber(finalBoqItem?.amount)}</span>
                  </div>
                </div>
              )}
              <div className="w-100"></div>
              </>}
              <div className="ed-box col-12 col-md-6 col-xl-4">
                <label htmlFor="vendorName" className="form-label">{vendorLabel} <span className='req-error'>*</span></label>
                <Select
                  isDisabled={isDisable}
                  key="vendorName"
                  className="basic-single"
                  classNamePrefix="select"
                  value={selectedVendorOption || null}
                  placeholder={langPreference?.select || "Select "}
                  isSearchable={true}
                  name="state"
                  options={vendors}
                  onChange={(e) => {
                    formik.setFieldValue("vendorName", e.label)
                    formik.setFieldValue("vendorId", e.value?._id)
                    formik.setFieldValue("Item", "")
                    formik.setFieldValue("uniqueItemId", "")
                  }}
                />
                <div className='text-danger'>{(formik?.touched?.vendorId && formik?.errors?.vendorId)}</div>
              </div>
              <div className="ed-box col-12 col-md-6 col-xl-4">
                <label htmlFor="Item" className="form-label">{itemServiceLabel} <span className='req-error'>*</span></label>
                <Select
                  isDisabled={!formik?.values?.vendorId || isDisable}
                  key={formik?.values?.vendorId}
                  className="basic-single"
                  classNamePrefix="select"
                  value={selectedItemOption || null}
                  placeholder={langPreference?.select || "Select "}
                  isSearchable={true}
                  name="Item"
                  options={items}
                  onChange={(e) => {
                    formik.setFieldValue("Item", e.label)
                    formik.setFieldValue("uniqueItemId", e.value?.uniqueItemId || "")
                  }}
                />
                {!formik?.values?.vendorId && !isDisable && <small className="text-muted">{langPreference?.select_subcontractor_first || "Select sub-contractor first"}</small>}
                <div className='text-danger'>{(formik?.touched?.uniqueItemId && formik?.errors?.uniqueItemId)}</div>
              </div>

              <div className="ed-box col-12 col-md-6 col-xl-4">
                <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                  <label htmlFor="to" className="form-label mb-0">{langPreference?.dpr_date || "DPR Date"} <span className='req-error'>*</span></label>
                  {!isDisable && <div className="d-flex flex-wrap gap-1">
                    <button type="button" className="btn btn-outline-secondary btn-sm py-0 px-2" onClick={() => setDatePreset("today")}>{langPreference?.today || "Today"}</button>
                    <button type="button" className="btn btn-outline-secondary btn-sm py-0 px-2" onClick={() => setDatePreset("thisWeek")}>{langPreference?.this_week || "This Week"}</button>
                    <button type="button" className="btn btn-outline-secondary btn-sm py-0 px-2" onClick={() => setDatePreset("thisMonth")}>{langPreference?.this_month || "This Month"}</button>
                    <button type="button" className="btn btn-outline-secondary btn-sm py-0 px-2" onClick={() => setDatePreset("lastMonth")}>{langPreference?.last_month || "Last Month"}</button>
                  </div>}
                </div>
                <DatePicker
                  disable={true}
                  disabled={isDisable}
                  selectsRange={true}
                  dateFormat="dd/MM/yyyy"
                  className='form-control cursor-pointer'
                  startDate={formik.values?.to ? formik.values?.to : null}
                  endDate={formik.values?.from ? formik.values?.from : null}
                  // maxDate={new Date(new Date(formik.values?.to ? formik.values?.to : new Date()).setTime(new Date(formik.values?.to ? formik.values?.to : new Date()).getTime() + (1 * 1000 * 60 * 60 * 24 * 180)))}
                  onChange={(update) => {
                    if (!isDisable) {
                      handleSelectDate(update[0], "to")
                      handleSelectDate(update[1], "from")
                    }
                  }}
                  isClearable={true && !isDisable}
                  placeholderText={langPreference?.from_to || "from - to"}
                  showDisabledMonthNavigation
                />
                <div className='text-danger'>{(formik?.touched?.from && formik?.errors?.from) || (formik?.touched?.to && formik?.errors?.to)}</div>
              </div>
            </div>
            {!isDisable && missingFilterFields?.length > 0 && (
              <div className="text-muted small text-end mt-2">
                {(langPreference?.missing_fields || "Missing")}: {missingFilterFields.join(", ")}
              </div>
            )}
            <div className="d-flex align-items-center justify-content-end mt-0">
              {
                isDisable ? <div disabled={resetDbData} className="save" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`}>
                  {resetDbData ? <Spinwheel /> : langPreference?.reset || "Reset"}

                </div> : <button type="button" className="save border-0" disabled={missingFilterFields?.length > 0} onClick={handleApply}>
                  {langPreference?.apply || "Apply"}
                </button>
              }

            </div>

          </form>
        </div>
        <ConfirmationModal modalId={confirmModalId} handleConfirm={handleConfirmation} message={langPreference?.confirm_reset_data || <>Are you sure you want to reset data <br />  ?</>} />
      </div>
    </>
  )
}

export default BillingFilter
